import React from 'react';
import { Modal } from 'antd';
import UploadPanel from './UploadPanel';
import UploadNarrow from './UploadNarrow';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import './upload.less';

export default class UploadModal extends React.Component {
    static defaultProps = {
    };

    static propTypes = {
        tips: PropTypes.string, // 页面脚底友情提示
    };

    constructor(props) {
        super(props);
        this.panelObj = {};
        this.state = {
            narrowVisible: false,
        }
    }

    /**
     * 当props发生变化时执行，初始化render时不执行，
     * 在这个回调函数里面，你可以根据属性的变化，通过调用this.setState()来更新你的组件状态，
     * 旧的属性还是可以通过this.props来获取,这里调用更新状态是安全的，并不会触发额外的render调用
     * 
     * @param {nextProps} nextProps 新的属性对象
     */
    componentWillReceiveProps(nextProps) {
        if (nextProps.visible === true) {
            //this.changeNarrowVisible();
        }
    }

    changeNarrowVisible = () => {
        let { narrowVisible } = this.state;
        this.setState({
            narrowVisible: !narrowVisible, 
        });
    }

    closeModal = () => {
        this.panelObj.uploadModelClose();
    }
    render() {
        let { visible, ...uploadPanelProps } = this.props;
        let { panelObj } = this;
        let { narrowVisible } = this.state;
        if (visible === false) {
            return null;
        }
        /** 缩小窗口 */
        const narrowProps = {
            visible: narrowVisible,
            changeNarrowVisible: this.changeNarrowVisible,
        }
        visible = !narrowVisible;
        return (
            <div>
                <Modal
                    title={window.language['material.upload']}
                    visible={visible}
                    onCancel={this.closeModal}
                    width={930}
                    maskClosable={false}
                    className="upload-panel"
                    footer={null}
                >
                    <span className="narrow-model" onClick={() => { this.changeNarrowVisible() }}><Icon className="minus-circle-o" /></span>
                    <UploadPanel panelObj={panelObj} {...uploadPanelProps} />
                </Modal>
                <UploadNarrow onClick={() => { this.changeNarrowVisible() }} {...narrowProps} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Upload/UploadModal.js